(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dar-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class DarNewsletterPopup extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;

      this.KEY_SUB = 'dar-np-subscribed';
      this.KEY_DIS = 'dar-np-dismissed';
      this.dias = parseInt(this.dataset.days, 10) || 14;
      this.enEditor = this.dataset.designMode === 'true';

      // Shopify recarga con ?customer_posted=true cuando el alta ha ido bien.
      // No se usa AJAX: /contact exige el captcha invisible y devuelve 400.
      const alta = new URLSearchParams(location.search).get('customer_posted') === 'true';
      if (alta) {
        this.marcar(this.KEY_SUB);
        this.revelar();
        this.abrir();
        return;
      }

      if (this.enEditor) { this.abrir(); this.enlazar(); return; }
      if (this.leido(this.KEY_SUB)) return;                 // ya suscrito: nunca mas
      if (this.leido(this.KEY_DIS)) return;                 // cerrado hace poco

      const espera = (parseInt(this.dataset.delay, 10) || 6) * 1000;
      // Si en ese momento el cliente esta BUSCANDO, el popup se le planta encima
      // del buscador y le tapa los resultados. Se pospone hasta que lo cierre.
      // No se abre encima de NADA que el cliente tenga abierto: el buscador, el
      // carrito lateral o cualquier dialogo. Su velo se pone por delante y deja
      // los botones muertos — medido: no se podia pulsar el "+" de las
      // sugerencias del carrito con el popup encima. Se pospone y reintenta.
      const ocupado = () =>
        document.body.classList.contains('dar-search-abierto') ||
        document.body.classList.contains('dar-zoom-abierto') ||
        !!document.querySelector('.page-wrapper--drawer-open') ||
        !!document.querySelector('dialog[open]');

      const cuandoToque = () => {
        if (ocupado()) {
          this.timer = setTimeout(cuandoToque, 2000);
          return;
        }
        this.abrir();
      };
      this.timer = setTimeout(cuandoToque, espera);
      this.enlazar();
    }

    enlazar() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-np-close]')) { this.cerrar(true); return; }
        const copiar = e.target.closest('[data-np-copy]');
        if (copiar) this.copiar(copiar);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.hidden) this.cerrar(true);
      });

      const form = this.querySelector('form');
      const boton = this.querySelector('[data-np-submit]');
      if (form && boton) {
        form.addEventListener('submit', () => {
          // OJO: deshabilitar el boton de forma SINCRONA aborta el envio en Chrome
          setTimeout(() => { boton.disabled = true; }, 0);
        });
      }
    }

    abrir() {
      this.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const campo = this.querySelector('input[type="email"]');
      if (campo) campo.focus({ preventScroll: true });
    }

    cerrar(anotar) {
      this.hidden = true;
      document.documentElement.style.overflow = '';
      clearTimeout(this.timer);
      if (anotar && !this.enEditor && !this.leido(this.KEY_SUB)) this.marcar(this.KEY_DIS);
    }

    revelar() {
      const form = this.querySelector('[data-np-form]');
      const done = this.querySelector('[data-np-done]');
      if (form) form.hidden = true;
      if (done) done.hidden = false;
    }

    copiar(btn) {
      const code = (this.querySelector('[data-np-code]') || {}).textContent || '';
      const fin = () => {
        const antes = btn.textContent;
        btn.textContent = btn.dataset.copied || 'Copied';
        setTimeout(() => { btn.textContent = antes; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code.trim()).then(fin).catch(() => fin());
      } else {
        // navegadores sin Clipboard API (o sin https): seleccion manual
        const r = document.createRange();
        r.selectNodeContents(this.querySelector('[data-np-code]'));
        const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
        fin();
      }
    }

    marcar(k) {
      try { localStorage.setItem(k, String(Date.now())); } catch (e) {}
    }

    leido(k) {
      try {
        const v = localStorage.getItem(k);
        if (!v) return false;
        if (k === this.KEY_SUB) return true;                 // suscrito: para siempre
        return (Date.now() - parseInt(v, 10)) < this.dias * 86400000;
      } catch (e) { return false; }
    }
  }
  if (!customElements.get('dar-newsletter-popup')) {
    customElements.define('dar-newsletter-popup', DarNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dar-recent-sales"] && !Shopify.designMode) return;
  try {
    
  class DarRecentSales extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;

      this.KEY = 'dar-rs-closed';
      this.items = [].slice.call(this.querySelectorAll('[data-rs-item]'));
      if (!this.items.length) return;

      this.enEditor = this.dataset.designMode === 'true';
      this.visible = (parseInt(this.dataset.visible, 10) || 6) * 1000;
      this.gap = (parseInt(this.dataset.gap, 10) || 12) * 1000;
      this.max = parseInt(this.dataset.max, 10) || 5;
      this.mostrados = 0;
      this.i = 0;

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-rs-close]')) { e.preventDefault(); this.cerrar(); }
      });

      if (this.enEditor) { this.mostrar(); return; }   // en el editor, siempre visible
      if (this.cerradoAntes()) return;

      const espera = (parseInt(this.dataset.delay, 10) || 10) * 1000;
      this.t = setTimeout(() => this.ciclo(), espera);
    }

    ciclo() {
      if (this.mostrados >= this.max) { this.hidden = true; return; }
      this.mostrar();
      this.t = setTimeout(() => {
        this.hidden = true;
        this.t = setTimeout(() => this.ciclo(), this.gap);
      }, this.visible);
    }

    mostrar() {
      this.items.forEach((el, n) => { el.hidden = n !== this.i; });
      this.i = (this.i + 1) % this.items.length;
      this.mostrados += 1;
      this.hidden = false;
    }

    cerrar() {
      clearTimeout(this.t);
      this.hidden = true;
      if (this.enEditor) return;
      try { sessionStorage.setItem(this.KEY, '1'); } catch (e) {}
    }

    cerradoAntes() {
      // sessionStorage y no localStorage: si lo cierra, se respeta durante ESA
      // visita; en la siguiente vuelve a estar disponible.
      try { return sessionStorage.getItem(this.KEY) === '1'; } catch (e) { return false; }
    }
  }
  if (!customElements.get('dar-recent-sales')) {
    customElements.define('dar-recent-sales', DarRecentSales);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dar-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Judge.me marca el contenedor con `jdgm--done-setup-widget` cuando ha acabado.
     Si al acabar lo ha dejado VACIO es que el producto no tiene resenas: entonces
     se destapa nuestro estado vacio. Se observa el contenedor porque la app
     hidrata en diferido y puede tardar segundos. */
  (function () {
    if (window.__darRev) return;
    window.__darRev = true;

    function enlaceDeJudgeme() {
      return document.querySelector('.jdgm-write-rev-link, .jdgm-widget .jdgm-write-rev-link');
    }

    function revisar() {
      document.querySelectorAll('.dar-rev').forEach(function (sec) {
        var w = sec.querySelector('#judgeme_product_reviews');
        var vacio = sec.querySelector('[data-rev-empty]');
        if (!w || !vacio) return;
        var sinContenido = w.innerHTML.trim().length === 0;
        var terminado = /jdgm--done-setup/.test(w.className);
        vacio.hidden = !(sinContenido && terminado);

        // El boton solo se pinta si Judge.me tiene su formulario disponible: un
        // boton que no abre nada es peor que no ponerlo. El mensaje se queda.
        var btn = vacio.querySelector('[data-rev-write]');
        if (btn) btn.hidden = !enlaceDeJudgeme();
      });
    }

    function arrancar() {
      revisar();
      document.querySelectorAll('#judgeme_product_reviews').forEach(function (w) {
        if (!window.MutationObserver) return;
        new MutationObserver(function () {
          clearTimeout(window.__darRevT);
          window.__darRevT = setTimeout(revisar, 120);
        }).observe(w, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      });
      // red de seguridad por si la app termina sin mutar el nodo observado
      setTimeout(revisar, 2500);
      setTimeout(revisar, 6000);

      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-rev-write]')) return;
        // Siempre el formulario de la PROPIA app: asi el envio, la validacion y
        // la verificacion de compra siguen siendo los de Judge.me.
        var link = enlaceDeJudgeme();
        if (link) link.click();
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dar-size-guide"] && !Shopify.designMode) return;
  try {
    
  /* Conmutador cm / pulgadas. Las dos unidades ya estan en el HTML: aqui solo se
     alterna `hidden`, nunca se recalcula un valor (una conversion en JS acaba
     mostrando decimales que no coinciden con la tabla oficial del fabricante). */
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sg-unit]');
      if (!btn) return;
      var wrap = btn.closest('[data-sg-unitwrap]');
      if (!wrap) return;
      var unit = btn.getAttribute('data-sg-unit');
      wrap.querySelectorAll('[data-sg-unit]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      wrap.querySelectorAll('[data-sg-cm]').forEach(function (el) { el.hidden = unit !== 'cm'; });
      wrap.querySelectorAll('[data-sg-in]').forEach(function (el) { el.hidden = unit !== 'in'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dar-testimonials"] && !Shopify.designMode) return;
  try {
    
  /* Flechas del carrusel. El desplazamiento lo hace el SCROLL NATIVO (scroll-snap),
     aqui solo se empuja una "pagina" y se activan/desactivan las flechas en los
     extremos. Asi el deslizamiento con el dedo en movil sigue funcionando solo. */
  (function () {
    if (window.__darTst) return;
    window.__darTst = true;

    function paso(track) {
      var card = track.querySelector('.dar-tst__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    /* Cuantas "paginas" hay: el ancho desplazable entre lo que se ve de una vez.
       Depende del ancho, asi que se recalcula tambien al redimensionar. */
    function paginas(track) {
      return Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
    }

    function pintarPuntos(root) {
      var cont = root.querySelector('[data-tst-dots]');
      var track = root.querySelector('[data-tst-track]');
      if (!cont || !track) return;
      var n = paginas(track);
      if (n < 2) { cont.innerHTML = ''; return; }        // una sola pagina: sin puntos
      if (cont.children.length !== n) {
        var etiqueta = cont.dataset.dotLabel || 'Reviews';
        cont.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'dar-tst__dot';
          b.setAttribute('aria-label', etiqueta + ' ' + (i + 1) + ' / ' + n);
          b.dataset.i = i;
          cont.appendChild(b);
        }
      }
      var activo = Math.round(track.scrollLeft / track.clientWidth);
      [].forEach.call(cont.children, function (d, i) {
        d.classList.toggle('is-on', i === activo);
      });
    }

    function refresh(root) {
      var track = root.querySelector('[data-tst-track]');
      var prev = root.parentElement && root.parentElement.querySelector('[data-tst-prev]');
      var next = root.parentElement && root.parentElement.querySelector('[data-tst-next]');
      if (!track) return;
      // margen de 2px: el scroll fraccionado nunca cuadra al pixel exacto
      var fin = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= fin;
      pintarPuntos(root);
    }

    function rootDe(btn) {
      var sec = btn.closest('.dar-tst');
      return sec ? sec.querySelector('[data-tst]') : null;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tst-prev], [data-tst-next]');
      if (!btn) return;
      var root = rootDe(btn);
      if (!root) return;
      var track = root.querySelector('[data-tst-track]');
      var dir = btn.hasAttribute('data-tst-next') ? 1 : -1;
      track.scrollBy({ left: dir * paso(track), behavior: 'smooth' });
    });

    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.dar-tst__dot');
      if (!dot) return;
      var sec = dot.closest('.dar-tst');
      var track = sec && sec.querySelector('[data-tst-track]');
      if (!track) return;
      track.scrollTo({ left: (+dot.dataset.i) * track.clientWidth, behavior: 'smooth' });
    });

    function boot() {
      document.querySelectorAll('[data-tst]').forEach(function (root) {
        var track = root.querySelector('[data-tst-track]');
        if (!track || track.__init) return;
        track.__init = true;
        track.addEventListener('scroll', function () { refresh(root); }, { passive: true });
        window.addEventListener('resize', function () { refresh(root); });
        refresh(root);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
